import { type PropsWithChildren } from "react";

const SPARKLE_1 = "https://cur.glitter-graphics.net/pub/3682/3682034mxl55jw25d.gif";
const SPARKLE_2 = "https://i.pinimg.com/originals/0f/38/17/0f3817da1af829075774018b36ebb587.gif";
const SPARKLE_3 =
    "https://64.media.tumblr.com/c9e2e16ed9d4bbf67ca885695c7658a1/643b1c04f542afb1-a7/s1280x1920/2b3259961cf748b661e31f578025897bca1e0873.gif";
const SPARKLE_4 = "https://i.pinimg.com/originals/79/69/17/796917271f530946a2775f66e8712f4b.gif";
const HORSE_GIF = "https://imgproxy.attic.sh/insecure/f:webp/q:90/w:1920/plain/https://attic.sh/rp8twcspfzo19mww1yy0vfas6r7k";

const TOP_FRIENDS = [
    { name: "Django", emoji: "😎", note: "(ur fav)" },
    { name: "Horse", emoji: "🐴", note: "BFF 4ever" },
    { name: "Floor", emoji: "😌", note: "" },
    { name: "Max Verstappen", emoji: "🚗", note: "" },
];

const COMMENTS = [
    { from: "Horse 🐴", msg: "Ana ur literally the best human ily 4ever no cap" },
    { from: "Django 😎", msg: "thx 4 keeping me on ur top 8!!1!" },
    { from: "Joshua 🥺", msg: "please let me make the button glow" },
];

const BOX: React.CSSProperties = {
    border: "3px ridge #9900cc",
    background: "rgba(26,0,51,0.95)",
    padding: "10px",
    marginBottom: "10px",
};

const BOX_TITLE: React.CSSProperties = {
    color: "#ff99cc",
    fontFamily: '"Comic Sans MS", cursive',
    margin: "0 0 8px 0",
    fontSize: "13px",
    borderBottom: "1px solid #9900cc",
    paddingBottom: "4px",
};

const FAKE_BUTTON: React.CSSProperties = {
    border: "1px solid #ffffff",
    color: "white",
    fontFamily: '"Comic Sans MS", cursive',
    fontSize: "11px",
    padding: "3px 6px",
    cursor: "pointer",
    width: "100%",
    marginBottom: "4px",
};

export default function AnasMySpaceFrills({ children }: PropsWithChildren) {
    return (
        <>
            <style>{`
                @keyframes anas-marquee {
                    0%   { transform: translateX(100vw); }
                    100% { transform: translateX(-100%); }
                }
                @keyframes anas-rainbow {
                    0%   { color: #ff0000; text-shadow: 3px 3px 0 #ff00ff, 0 0 30px #ff0000; }
                    16%  { color: #ff9900; text-shadow: 3px 3px 0 #ffcc00, 0 0 30px #ff9900; }
                    33%  { color: #ffff00; text-shadow: 3px 3px 0 #ccff00, 0 0 30px #ffff00; }
                    50%  { color: #00ff88; text-shadow: 3px 3px 0 #00ffcc, 0 0 30px #00ff88; }
                    66%  { color: #00ccff; text-shadow: 3px 3px 0 #0066ff, 0 0 30px #00ccff; }
                    83%  { color: #cc66ff; text-shadow: 3px 3px 0 #ff00ff, 0 0 30px #cc66ff; }
                    100% { color: #ff0000; text-shadow: 3px 3px 0 #ff00ff, 0 0 30px #ff0000; }
                }
                @keyframes anas-pulse {
                    0%   { border-color: #ff69b4; box-shadow: 0 0 6px #ff69b4; }
                    50%  { border-color: #bf00ff; box-shadow: 0 0 22px #bf00ff; }
                    100% { border-color: #ff69b4; box-shadow: 0 0 6px #ff69b4; }
                }
                @keyframes anas-blink {
                    0%, 100% { opacity: 1; }
                    50%       { opacity: 0; }
                }
                .anas-rainbow  { animation: anas-rainbow 2.5s linear infinite; }
                .anas-pulse    { animation: anas-pulse 2s ease-in-out infinite; }
                .anas-blink    { animation: anas-blink 1s step-end infinite; }
            `}</style>

            {/* Fixed corner sparkles */}
            <img
                src={SPARKLE_1}
                alt="✨"
                style={{ position: "fixed", top: 64, left: 8, width: 72, zIndex: 9999, pointerEvents: "none" }}
            />
            <img
                src={SPARKLE_2}
                alt="✨"
                style={{ position: "fixed", top: 64, right: 8, width: 72, zIndex: 9999, pointerEvents: "none" }}
            />
            <img
                src={SPARKLE_3}
                alt="✨"
                style={{ position: "fixed", bottom: 8, left: 8, width: 72, zIndex: 9999, pointerEvents: "none" }}
            />
            <img
                src={SPARKLE_4}
                alt="✨"
                style={{ position: "fixed", bottom: 8, right: 8, width: 72, zIndex: 9999, pointerEvents: "none" }}
            />

            <div
                style={{
                    fontFamily: '"Comic Sans MS", "Comic Sans", cursive',
                    background: "#0d0026",
                    backgroundImage: "radial-gradient(circle at 1px 1px, rgba(255,105,180,0.25) 1px, transparent 0)",
                    backgroundSize: "20px 20px",
                    minHeight: "100vh",
                    padding: "8px",
                    color: "#ff69b4",
                    position: "relative",
                }}
            >
                {/* Marquee */}
                <div
                    style={{
                        background: "linear-gradient(90deg, #ff00ff, #bf00ff)",
                        color: "#ffff00",
                        padding: "4px 0",
                        fontSize: "13px",
                        fontWeight: "bold",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        marginBottom: "10px",
                    }}
                >
                    <span style={{ display: "inline-block", animation: "anas-marquee 22s linear infinite" }}>
                        ✨💖 WELCOME 2 ANA'S SPACE!! 💖✨ &nbsp;&nbsp;&nbsp; ur visiting the BEST product owner in da whole
                        world!!! &nbsp;&nbsp;&nbsp; so blessed 2 be here 🙏 &nbsp;&nbsp;&nbsp; ✨💖 WELCOME 2 ANA'S SPACE!! 💖✨
                        &nbsp;&nbsp;&nbsp; ur visiting the BEST product owner in da whole world!!!
                    </span>
                </div>

                {/* Title */}
                <h1
                    className="anas-rainbow"
                    style={{
                        textAlign: "center",
                        fontFamily: 'Impact, "Arial Black", sans-serif',
                        fontSize: "42px",
                        margin: "0 0 4px 0",
                        letterSpacing: "3px",
                    }}
                >
                    ✨ Ana's Space ✨
                </h1>
                <p style={{ textAlign: "center", fontSize: "12px", color: "#ff99cc", margin: "0 0 12px 0" }}>
                    <span className="anas-blink">🌟</span> Best. Product. Owner. Ever. <span className="anas-blink">🌟</span>
                </p>

                {/* Three-column MySpace table */}
                <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "6px" }}>
                    <tbody>
                        <tr style={{ verticalAlign: "top" }}>
                            {/* ── LEFT: Profile ── */}
                            <td style={{ width: "200px" }}>
                                <div
                                    className="anas-pulse"
                                    style={{
                                        border: "3px ridge #ff69b4",
                                        background: "rgba(26,0,51,0.95)",
                                        padding: "8px",
                                        marginBottom: "8px",
                                    }}
                                >
                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                            color: "#ff00ff",
                                            marginBottom: "4px",
                                        }}
                                    >
                                        AnaPO_xoxo 💅
                                    </div>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontSize: "11px",
                                            color: "#00ff88",
                                            marginBottom: "6px",
                                        }}
                                    >
                                        🟢 Online Now!
                                    </div>
                                    <div
                                        style={{
                                            border: "3px double #bf00ff",
                                            overflow: "hidden",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        <img src={HORSE_GIF} alt="🐴" style={{ width: "100%", display: "block" }} />
                                    </div>
                                    <div style={{ fontSize: "11px", lineHeight: "1.9", color: "#ffb3d9" }}>
                                        <div>
                                            🎂 <b>Age:</b> 21 (always)
                                        </div>
                                        <div>
                                            📍 <b>Location:</b> ur heart
                                        </div>
                                        <div>
                                            💼 <b>Job:</b> Ruler of the Product
                                        </div>
                                        <div>
                                            😊 <b>Mood:</b> Building Features 💻🔥
                                        </div>
                                        <div>
                                            💌 <b>Last login:</b> Online now!!
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "8px" }}>
                                        <button
                                            type="button"
                                            style={{
                                                ...FAKE_BUTTON,
                                                background: "linear-gradient(180deg,#cc99ff,#9933ff)",
                                            }}
                                        >
                                            💌 Send Message
                                        </button>
                                        <button
                                            type="button"
                                            style={{
                                                ...FAKE_BUTTON,
                                                background: "linear-gradient(180deg,#ff99cc,#ff0066)",
                                            }}
                                        >
                                            ➕ Add to Friends
                                        </button>
                                        <button
                                            type="button"
                                            style={{
                                                ...FAKE_BUTTON,
                                                background: "linear-gradient(180deg,#99ccff,#3366cc)",
                                            }}
                                        >
                                            🚫 Block User
                                        </button>
                                    </div>
                                </div>

                                <div style={{ textAlign: "center", marginBottom: "6px" }}>
                                    <img src={SPARKLE_2} alt="✨" style={{ width: "80px" }} />
                                </div>

                                {/* Blinkies */}
                                <div style={{ border: "2px solid #ff69b4", background: "#1a0033", padding: "6px" }}>
                                    <div
                                        style={{
                                            color: "#ffff00",
                                            textAlign: "center",
                                            marginBottom: "5px",
                                            fontWeight: "bold",
                                            fontSize: "11px",
                                        }}
                                    >
                                        My Blinkies!!
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "3px",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {[
                                            "🌺 ana rules",
                                            "💖 PO 4ever",
                                            "✨ iconic",
                                            "🐴 horse girl",
                                            "👑 queen",
                                            "📋 scrum lyf",
                                        ].map(txt => (
                                            <span
                                                key={txt}
                                                style={{
                                                    background: "linear-gradient(90deg, #ff00ff, #0000ff)",
                                                    color: "white",
                                                    fontSize: "10px",
                                                    padding: "2px 5px",
                                                    border: "1px solid white",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {txt}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </td>

                            {/* ── CENTRE: Main content ── */}
                            <td>
                                {/* Horse speech bubble */}
                                <div style={{ ...BOX, border: "3px ridge #ffff00" }}>
                                    <div
                                        style={{
                                            fontSize: "11px",
                                            color: "#ffdd00",
                                            marginBottom: "6px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        🐴 YR HORSE HAS A MESSAGE FOR U:
                                    </div>
                                    <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                        <img
                                            src={HORSE_GIF}
                                            alt="🐴"
                                            style={{ width: "80px", flexShrink: 0, border: "2px solid #ff69b4" }}
                                        />
                                        <div
                                            style={{
                                                background: "white",
                                                color: "#333",
                                                padding: "10px 14px",
                                                borderRadius: "12px",
                                                fontFamily: '"Comic Sans MS", cursive',
                                                fontSize: "13px",
                                                border: "2px solid #ff69b4",
                                                position: "relative",
                                                flex: 1,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: "-15px",
                                                    top: "12px",
                                                    width: 0,
                                                    height: 0,
                                                    borderTop: "8px solid transparent",
                                                    borderBottom: "8px solid transparent",
                                                    borderRight: "15px solid white",
                                                }}
                                            />
                                            "Ana!! OMG!! You are literally the MOST amazing Product Owner to ever exist on this
                                            earth 🌍 Your user stories are FLAWLESS, your roadmaps are works of art 🎨 and the dev
                                            team would be completely LOST without ur brilliant vision. Never change, ur literally
                                            a legend 🐴✨👑"
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            textAlign: "right",
                                            fontSize: "10px",
                                            color: "#ff99cc",
                                            marginTop: "6px",
                                        }}
                                    >
                                        — yr biggest fan, Horse 🐴
                                    </div>
                                </div>

                                {/* Sparkle divider */}
                                <div style={{ textAlign: "center", margin: "4px 0 10px" }}>
                                    {(["s1a", "s3a", "s2a", "s3b", "s1b"] as const).map((id, i) => (
                                        <img
                                            key={id}
                                            src={[SPARKLE_1, SPARKLE_3, SPARKLE_2, SPARKLE_3, SPARKLE_1][i]}
                                            alt="✨"
                                            style={{ width: "52px", margin: "0 4px" }}
                                        />
                                    ))}
                                </div>

                                {/* Ana's Power Tools — children slot */}
                                <div className="anas-pulse" style={{ ...BOX, border: "4px ridge #ff00ff" }}>
                                    <h2
                                        style={{
                                            fontFamily: "Impact, sans-serif",
                                            color: "#ff00ff",
                                            textAlign: "center",
                                            margin: "0 0 6px 0",
                                            fontSize: "22px",
                                            textShadow: "2px 2px 0 #000, 0 0 12px #ff00ff",
                                            letterSpacing: "2px",
                                        }}
                                    >
                                        ⚡ ANA'S POWER TOOLS ⚡
                                    </h2>
                                    <p
                                        style={{
                                            fontSize: "11px",
                                            color: "#cc99ff",
                                            textAlign: "center",
                                            margin: "0 0 12px 0",
                                        }}
                                    >
                                        ⚠️ WARNING: Only THE CHOSEN ONE (Ana) may use these tools 🔮
                                    </p>
                                    <div style={{ textAlign: "center" }}>{children}</div>
                                </div>

                                {/* About Me */}
                                <div style={BOX}>
                                    <h3 style={BOX_TITLE}>💖 About Me</h3>
                                    <p style={{ fontSize: "12px", color: "#ffb3d9", margin: 0, lineHeight: "1.7" }}>
                                        Hii!!! I'm Ana, ur fav Product Owner 🌟 I spend my days turning chaos into epic user
                                        stories and making devs cry (with joy ofc 💅). My hobbies include: writing acceptance
                                        criteria that are actually good, saying "that's out of scope" with a smile 😇,
                                        facilitating the BEST retros, and generally being an absolutely iconic human being. My
                                        spirit animal is obviously a horse 🐴. Status: Accepting backlog refinement requests 📋✨
                                    </p>
                                </div>

                                {/* Interests */}
                                <div style={BOX}>
                                    <h3 style={BOX_TITLE}>🎵 Ana's Interests</h3>
                                    <table style={{ width: "100%", fontSize: "11px", color: "#cc99ff" }}>
                                        <tbody>
                                            {[
                                                ["Watching", "Max Verstappen win the car racing thing"],
                                                ["Riding", "A horse"],
                                                ["Video game", "Warframe"],
                                                ["Favourite devs", "Remco, Django, Codie Jodie, and of course Joshua"],
                                                ["Top designer", "Pola"],
                                            ].map(([label, value]) => (
                                                <tr key={label}>
                                                    <td
                                                        style={{
                                                            paddingBottom: "4px",
                                                            paddingRight: "8px",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        <b style={{ color: "#ff99cc" }}>{label}:</b>
                                                    </td>
                                                    <td style={{ paddingBottom: "4px" }}>{value}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </td>

                            {/* ── RIGHT: Extras ── */}
                            <td style={{ width: "190px" }}>
                                {/* Fake Winamp player */}
                                <div
                                    style={{
                                        border: "2px solid #336699",
                                        background: "#000033",
                                        marginBottom: "8px",
                                        fontSize: "11px",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "linear-gradient(180deg,#6699cc,#336699)",
                                            color: "white",
                                            padding: "3px 6px",
                                            fontWeight: "bold",
                                            fontSize: "11px",
                                            fontFamily: "Tahoma, sans-serif",
                                        }}
                                    >
                                        🎵 Ana's Profile Song
                                    </div>
                                    <div style={{ padding: "6px", color: "#9999ff" }}>
                                        <div style={{ color: "white", fontWeight: "bold", marginBottom: "2px" }}>
                                            ♪ Kalinka – Ivan Larionov
                                        </div>
                                        <div style={{ color: "#6699cc", fontSize: "10px", marginBottom: "6px" }}>
                                            In The Zone (2003)
                                        </div>
                                        <div
                                            style={{
                                                background: "#001133",
                                                padding: "5px",
                                                border: "1px inset #336699",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-around",
                                                    marginBottom: "4px",
                                                    color: "#cc99ff",
                                                    fontSize: "14px",
                                                    cursor: "default",
                                                }}
                                            >
                                                <span>⏮</span>
                                                <span>⏸</span>
                                                <span>⏭</span>
                                                <span>🔊</span>
                                            </div>
                                            <div
                                                style={{
                                                    background: "#336699",
                                                    height: "4px",
                                                    width: "100%",
                                                    position: "relative",
                                                }}
                                            >
                                                <div style={{ background: "#99ccff", height: "4px", width: "62%" }} />
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    fontSize: "9px",
                                                    color: "#6699cc",
                                                    marginTop: "2px",
                                                }}
                                            >
                                                <span>1:23</span>
                                                <span>2:19</span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "9px",
                                                color: "#336699",
                                                marginTop: "4px",
                                                textAlign: "center",
                                            }}
                                        >
                                            🔁 Repeat: ON &nbsp; 🔀 Shuffle: ON
                                        </div>
                                    </div>
                                </div>

                                {/* Top Friends */}
                                <div style={{ ...BOX, padding: "8px" }}>
                                    <h3 style={BOX_TITLE}>👯 Ana's Top Friends</h3>
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>
                                        {TOP_FRIENDS.map(f => (
                                            <div key={f.name} style={{ textAlign: "center", fontSize: "10px", color: "#cc99ff" }}>
                                                <div
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        background: "linear-gradient(135deg,#660066,#330033)",
                                                        border: "2px solid #ff69b4",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "24px",
                                                        margin: "0 auto 3px",
                                                    }}
                                                >
                                                    {f.emoji}
                                                </div>
                                                <div style={{ color: "#ff99cc", fontWeight: "bold" }}>{f.name}</div>
                                                <div style={{ fontSize: "9px" }}>{f.note}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Visitor counter */}
                                <div
                                    style={{
                                        border: "2px solid #336600",
                                        background: "#001100",
                                        padding: "6px",
                                        textAlign: "center",
                                        marginBottom: "8px",
                                        fontFamily: '"Courier New", monospace',
                                    }}
                                >
                                    <div style={{ color: "#00cc00", fontSize: "10px", marginBottom: "2px" }}>VISITOR COUNT</div>
                                    <div
                                        style={{
                                            color: "#00ff00",
                                            fontSize: "22px",
                                            fontWeight: "bold",
                                            letterSpacing: "4px",
                                        }}
                                    >
                                        2003
                                    </div>
                                    <div style={{ color: "#006600", fontSize: "9px" }}>since jan 1 2003</div>
                                </div>

                                <div style={{ textAlign: "center", marginBottom: "8px" }}>
                                    <img src={SPARKLE_4} alt="✨" style={{ width: "70px" }} />
                                </div>

                                {/* Comments */}
                                <div style={{ ...BOX, padding: "8px" }}>
                                    <h3 style={BOX_TITLE}>💬 Comments</h3>
                                    {COMMENTS.map(c => (
                                        <div
                                            key={c.from}
                                            style={{
                                                borderBottom: "1px dotted #660066",
                                                paddingBottom: "6px",
                                                marginBottom: "6px",
                                            }}
                                        >
                                            <div style={{ color: "#ff69b4", fontWeight: "bold", fontSize: "10px" }}>{c.from}</div>
                                            <div style={{ color: "#cc99ff", fontSize: "10px" }}>{c.msg}</div>
                                        </div>
                                    ))}
                                    <div style={{ textAlign: "center" }}>
                                        <button
                                            type="button"
                                            style={{
                                                background: "linear-gradient(180deg,#cc99ff,#9933ff)",
                                                border: "1px solid white",
                                                color: "white",
                                                fontFamily: '"Comic Sans MS", cursive',
                                                fontSize: "10px",
                                                padding: "2px 8px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Add Comment
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Footer */}
                <div style={{ textAlign: "center", marginTop: "20px", paddingBottom: "20px" }}>
                    {(["f1", "f2", "f3", "f4", "f2b"] as const).map((id, i) => (
                        <img
                            key={id}
                            src={[SPARKLE_1, SPARKLE_2, SPARKLE_3, SPARKLE_4, SPARKLE_2][i]}
                            alt="✨"
                            style={{ width: "48px", margin: "0 3px" }}
                        />
                    ))}
                    <div
                        style={{
                            color: "#440044",
                            fontSize: "10px",
                            marginTop: "8px",
                            fontFamily: "Tahoma, sans-serif",
                        }}
                    >
                        © 2003–2026 Ana's Space™ · Layout by AnaPO_xoxo · Best viewed in Internet Explorer 6.0 at 800×600
                        resolution
                    </div>
                </div>
            </div>
        </>
    );
}
